import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { SellerAllocationQueueModel } from '../../../../../models';

@Injectable({
  providedIn: 'root'
})
export class SellerAllocationQueueService extends BaseApiTemplateService<SellerAllocationQueueModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mkp/seller-allocation-queues/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mkp/seller-allocation-queues/backoffice-ep';
    this.httpClient = http;
  }
}